const routes = [
    {
        path: "/elective/pools",
        component: () => import("../pages/ElectivePoolsTable"),
        meta: {
            isAuthenticated: true,
            permission: "electivepool_index"
        }
    },
    {
        path: "/elective/pools/report",
        component: () => import("../pages/Report"),
        meta: {
            isAuthenticated: true,
            permission: "electivepool_report"
        }
    }

];

export default routes;
